import styled, { keyframes } from 'styled-components';
import { Box } from 'modules/Box';
import { theme } from 'modules/tetrisTheme';
import { responsiveProperty } from 'modules/utils/responsiveProperty';
const backgroundAnimation = keyframes `
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;
const getAppearanceColors = (appearance) => {
    switch (appearance) {
        case 'purple':
            return {
                color1: `color-mix(in srgb, ${theme.swatches.purple[50]}, transparent 60%)`,
                color2: `color-mix(in srgb, ${theme.swatches.purple[100]}, transparent 40%)`,
            };
        case 'gray':
        default:
            return {
                color1: `color-mix(in srgb, ${theme.swatches.gray[50]}, transparent 60%)`,
                color2: `color-mix(in srgb, ${theme.swatches.gray[100]}, transparent 40%)`,
            };
    }
};
export const SkeletonBox = styled(Box) `
  ${(props) => props.height && responsiveProperty('height', props.height)};
  ${(props) => props.width && responsiveProperty('width', props.width)};

  ${(props) => responsiveProperty('borderRadius', props.borderRadius || theme.borderRadius.md)};

  background: ${(props) => {
    const colors = getAppearanceColors(props.appearance);
    return `linear-gradient(
      -45deg,
      ${colors.color1},
      ${colors.color2},
      ${colors.color1},
      ${colors.color2}
    )`;
}};
  background-size: 400% 400%;
  animation: ${backgroundAnimation} 3s ease infinite;
  border: none;
  box-shadow: none;
  box-decoration-break: clone;
  color: transparent;
  outline: none;
  pointer-events: none;
  user-select: none;
  cursor: default;

  & > *,
  &::after,
  &::before {
    visibility: hidden;
  }
`;
